module.exports = __webpack_public_path__ + "img/slider_betterdoc.236ab243.svg";